import React, { useState, useEffect } from "react";
import { Icon } from '@iconify/react/dist/iconify.js';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//import { useNavigate } from "react-router-dom";

const CustomRescuersFormPageUpdate = ({ rescuerId }) => {
  const API_BASE_URL = process.env.REACT_APP_BE_API_URL;
  //const navigate = useNavigate();
  const [formData, setFormData] = useState({
    division: "",
    sub_division: "",
    block: "",
    cpt_no: "",
    rescuer_name: "",
    parentage: "",
    rescuer_address: "",
    rescuer_contact_no: "",
    rescuer_cnic_no: "",
    rescuer_type: "",
    rescuer_coordinates: {
      latitude: "",
      longitude: ""
    }
  });

  const [rescuerTypeOptions] = useState([
    { id: "Volunteer", name: "Volunteer" },
    { id: "Fire Fighter", name: "Fire Fighter" },
    { id: "Rakhas", name: "Fire Watchers (Rakhas)" },
  ]);

  
  // Fetch rescuer data on component mount
  useEffect(() => {
    const fetchRescuerData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${API_BASE_URL}/backend/rescuers/${rescuerId}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });
        
        if (response.data.status) {
          setFormData(response.data.data);
        }
      } catch (error) {
        toast.error("Failed to fetch rescuer data.");
        console.error("Error fetching rescuer data:", error);
      }
    };

    fetchRescuerData();
  }, [rescuerId, API_BASE_URL]);

  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name.includes("coordinates")) {
      const coordName = name.split(".")[1]; // Get latitude or longitude
      setFormData((prevData) => ({
        ...prevData,
        rescuer_coordinates: {
          ...prevData.rescuer_coordinates,
          [coordName]: value,
        },
      }));
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  
  const handleSubmit = async (e) => {
    e.preventDefault();

    const requiredFields = [
      "division",
      "sub_division",
      "block",
      "cpt_no",
      "rescuer_name",
      "parentage",
      "rescuer_address",
      "rescuer_contact_no",
      "rescuer_cnic_no",
      "rescuer_type",
      "rescuer_coordinates.latitude",
      "rescuer_coordinates.longitude"
    ];

    const isFormValid = requiredFields.every((field) => {
      const keys = field.split(".");
      return keys.length === 1 ? formData[keys[0]] !== "" : formData[keys[0]][keys[1]] !== "";
    });

    if (!isFormValid) {
      toast.error("Please fill in all required details!");
      return;
    }

    // Prepare data for API
    const apiData = {
      ...formData,
      rescuer_coordinates: {
        latitude: parseFloat(formData.rescuer_coordinates.latitude),
        longitude: parseFloat(formData.rescuer_coordinates.longitude),
      }
    };

    try {
      const token = localStorage.getItem("token");
      const response = await axios.patch(`${API_BASE_URL}/backend/rescuers/${rescuerId}`, apiData, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.data.status) {
        toast.success("Rescuer updated successfully!");
        //navigate("/rescures/list");
        
      }
    } catch (error) {
      toast.error("Failed to update rescuer. Please try again.");
      console.error("Error updating rescuer:", error);
    }
  };

  
  return (
    <div className="col-lg-12 col-md-12 col-sm-12">
      <form onSubmit={handleSubmit}>
        <div className="">
          <div className="text-center ">
            <h6 className="mb-20 text-2xl font-bold text-gray-800 flex items-center">
              <Icon icon="mdi:file-document-alert" className="text-3xl mx-3 my-1 " />
              Update Rescuer Form
            </h6>
          </div>
          <ToastContainer />
          <div className="">
            <div className="row gy-3">
              {/* Division */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:map" className="text-lg" />
                  Division
                </label>
                <input
                  type="text"
                  name="division"
                  placeholder="Division"
                  className="form-control"
                  value={formData.division}
                  onChange={handleInputChange}
                  required
                />
              </div>
              {/* Sub Division */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:map" className="text-lg" />
                  Sub Division
                </label>
                <input
                  type="text"
                  name="sub_division"
                  placeholder="Sub Division"
                  className="form-control"
                  value={formData.sub_division}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {/* Block */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:format-list-numbered" className="text-lg" />
                  Block
                </label>
                <input
                  type="text"
                  name="block"
                  placeholder="Block Number"
                  className="form-control"
                  value={formData.block}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {/* CPT No */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:format-list-numbered" className="text-lg" />
                  CPT No
                </label>
                <input
                  type="text"
                  name="cpt_no"
                  placeholder="CPT Number"
                  className="form-control"
                  value={formData.cpt_no}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {/* Rescuer Name */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:account" className="text-lg" />
                  Rescuer Name
                </label>
                <input
                  type="text"
                  name="rescuer_name"
                  placeholder="Rescuer Name"
                  className="form-control"
                  value={formData.rescuer_name}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {/* Parentage */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:account" className="text-lg" />
                  Parentage
                </label>
                <input
                  type="text"
                  name="parentage"
                  placeholder="Parentage"
                  className="form-control"
                  value={formData.parentage}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {/* Rescuer Address */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:home" className="text-lg" />
                  Rescuer Address
                </label>
                <input
                  type="text"
                  name="rescuer_address"
                  placeholder="Rescuer Address"
                  className="form-control"
                  value={formData.rescuer_address}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {/* Rescuer Contact No */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon=" mdi:phone" className="text-lg" />
                  Rescuer Contact No
                </label>
                <input
                  type="text"
                  name="rescuer_contact_no"
                  placeholder="Contact Number"
                  className="form-control"
                  value={formData.rescuer_contact_no}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {/* Rescuer CNIC No */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:card-account-details" className="text-lg" />
                  Rescuer CNIC No
                </label>
                <input
                  type="text"
                  name="rescuer_cnic_no"
                  placeholder="CNIC Number"
                  className="form-control"
                  value={formData.rescuer_cnic_no}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {/* Rescuer Type */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:account" className="text-lg" />
                  Rescuer Type
                </label>
                <select
                  className="form-select"
                  name="rescuer_type"
                  value={formData.rescuer_type}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Rescuer Type</option>
                  {rescuerTypeOptions.map((type) => (
                    <option key={type.id} value={type.id}>
                      {type.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Rescuer Coordinates */}
              <div className="col-lg-4 col-md-6 col-sm-12">
                <label className="form-label d-flex align-items-center gap-2">
                  <Icon icon="mdi:map-marker" className="text-lg" />
                  Rescuer Coordinates
                </label>
                <div className="d-flex gap-2">
                  <input
                    type="text"
                    name="rescuer_coordinates.latitude"
                    placeholder="Latitude"
                    className="form-control"
                    value={formData.rescuer_coordinates.latitude}
                    onChange={handleInputChange}
                    required
                  />
                  <input
                    type="text"
                    name="rescuer_coordinates.longitude"
                    placeholder="Longitude"
                    className="form-control"
                    value={formData.rescuer_coordinates.longitude}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-success text-sm btn-sm px-6 py-12 radius-12 my-24 mx-10 col-lg-4 col-md-6 col-sm-12"
              type="submit"
            >
              Update Rescuer
            </button>
          </div>
        </div>
      </form>

      <ToastContainer />
    </div>
  );
};

export default CustomRescuersFormPageUpdate;